/* PromptEditorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./PromptEditorWrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var promptEditorWrapperStylesUnbounded = null;
var promptEditorWrapperStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var promptEditorWrapperOverflowStyles = null;

// The types PromptEditorType should mirror what is in the editor-ai-injected-editors package
// at `platform/packages/editor/editor-ai-injected-editors/src/editors/types.ts.

// The types PromptEditorProps and PromptEditor should mirror what is in the editor-ai-injected-editors package
// at `packages/editor/editor-ai-injected-editors/src/editors/prompt.tsx`.

export var PromptEditorWrapper = function PromptEditorWrapper(_ref) {
  var type = _ref.type,
    PromptEditor = _ref.PromptEditor,
    defaultValue = _ref.defaultValue,
    autoFocus = _ref.autoFocus,
    focusInputRef = _ref.focusInputRef,
    blurInputRef = _ref.blurInputRef,
    clearInputRef = _ref.clearInputRef,
    placeholder = _ref.placeholder,
    enableLinks = _ref.enableLinks,
    onInputChange = _ref.onInputChange,
    onADFChange = _ref.onADFChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    onCompositionStart = _ref.onCompositionStart,
    onCompositionEnd = _ref.onCompositionEnd;
  var setFocusHandlers = useCallback(function (blur, focus) {
    if (blurInputRef) {
      blurInputRef.current = blur;
    }
    if (focusInputRef) {
      focusInputRef.current = focus;
    }
  }, [blurInputRef, focusInputRef]);
  var setClearHandler = useCallback(function (clear) {
    if (clearInputRef) {
      clearInputRef.current = clear;
    }
  }, [clearInputRef]);
  var componentId = useMemo(function () {
    return "".concat(placeholder, "-").concat(uuidv4());
  }, [placeholder]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "ai-experience-prompt-input",
    onKeyDown: onKeyDown
    // We're using this div to listen to focus/blur/composition events which bubble up.
    ,
    onFocus: onFocus,
    onBlur: onBlur,
    onCompositionStart: onCompositionStart,
    onCompositionEnd: onCompositionEnd,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c11p5 _kqswh2mm", "_1hxngktf _hmumidpf _12k3idpf _q5yz1wug _dcw6idpf _2ih3idpf", "_w79o1m6u _1hxn1tcg"])
  }, /*#__PURE__*/React.createElement(PromptEditor, {
    type: type,
    key: componentId,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    placeholder: placeholder,
    onInputChange: onInputChange,
    onADFChange: onADFChange,
    setFocusHandlers: setFocusHandlers,
    setClearHandler: setClearHandler,
    enableLinks: enableLinks
  }));
};